import React, { useState } from "react";
import styled from "styled-components";
import Breakpoints from "../components/styles/Breakpoints";
import DomeHeader from "../components/DomeHeader";
import { Colors } from "../components/styles/Colors";
import { Body, Header2, Header4Styles } from "../components/typography";
import richText from "../utils/richText";
import { current } from "immer";
import Chevron from "../components/Chevron";

const Wrapper = styled.div`
  padding: 64px 32px;

  background: ${Colors.cream2};

  ${Header2} {
    text-align: center;
    margin: 24px auto 40px;
    max-width: 660px;
  }

  @media ${Breakpoints.tablet} {
    padding: 128px 64px;
  }
`;

const FaqContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const FaqBody = styled(Body)``

const AccordionSection = styled.div`
  padding: 40px 0;
  width: 100%;

  border-bottom: 1px solid ${Colors.webGrey};

  &:last-of-type {
    border-bottom: 0;
  }

  > ${Body} {
    display: block;
    margin-top: 24px;

    p ~ p {
      margin-top: 15px;
    }
  }

  @media ${Breakpoints.tablet} {
    width: 50%;
  }

  ${FaqBody} {
    display: none;
  }

  &.active {
    ${FaqBody} {
      display: block;
    }

    svg {
      transform: rotate(180deg);
    }
  }
`;

const AccordionHeader = styled.button`
  ${Header4Styles}

  display: flex;
  text-align: left;

  justify-content: space-between;
  align-items: center;

  width: 100%;
  height: 32px;

  padding: 0;

  outline: none;

  color: ${Colors.grey};

  background: 0;
  border: 0;
`;

export default function FaqSection({ faqs }) {
  const [currentFaq, setCurrentFaq] = useState(null)

  function toggle (index) {
    if (currentFaq === index) {
      setCurrentFaq(null)
    } else {
      setCurrentFaq(index)
    }
  }

  return (
    <Wrapper id="faq">
      <DomeHeader text="Common Queries" centered />
      <Header2>Frequently Asked Questions</Header2>
      <FaqContainer>
        {faqs.map((item, index) => (
          <AccordionSection 
            className={ index === currentFaq ? 'active' : null }
          >
            <AccordionHeader 
              onClick={() => toggle(index)}
            >
              <span>{item.question.question}</span> <Chevron />
            </AccordionHeader>
            <FaqBody>{richText(item.answer.raw)}</FaqBody>
          </AccordionSection>
        ))}
      </FaqContainer>
    </Wrapper>
  );
}
